import React, { useState } from "react"
import Layout from "../templates/layout"
import styled from "styled-components"
import Card from "../components/CardProject.js"
import ProjetoData from "../data/ProjetosData.js"
import { Helmet } from "react-helmet"

export default function Home() {
  const [filtro, setFiltro] = useState("all")

  return (
      <Layout>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Luidy - Portfolio</title>
        </Helmet>
        <Container>
          <Header>
            <h1>Portfolio</h1>
            <p>Some projects I've developed along my career</p>
          </Header>
          <Filter>
            <span
              className={`${filtro === "all" ? "active" : "none"}`}
              onClickCapture={e => setFiltro("all")}
            >
              All
            </span>
            <span
              className={`${filtro === "web" ? "active" : "none"}`}
              onClickCapture={e => setFiltro("web")}
            >
              Web
            </span>

            <span
              className={`${filtro === "html" ? "active" : "none"}`}
              onClickCapture={e => setFiltro("html")}
            >
              HTML/CSS
            </span>
            <span
              className={`${filtro === "design" ? "active" : "none"}`}
              onClickCapture={e => setFiltro("design")}
            >
              UI/UX Design
            </span>
            <span
              className={`${filtro === "mobile" ? "active" : "none"}`}
              onClickCapture={e => setFiltro("mobile")}
            >
              Mobile
            </span>
          </Filter>
          <ContainerProject>
            {ProjetoData.filter(i => i.categorias.indexOf(filtro) > -1)
              .reverse()
              .map(pro => (
                <Card
                  key={pro.id}
                  id={pro.id}
                  dev={pro.dev}
                  name={pro.nome}
                  data={pro.data}
                  descricao={pro.descricao}
                  linguagens={pro.linguagens}
                  carrosselImg={pro.carrosselImg}
                  img={pro.img}
                  link={pro.link}
                />
              ))}
          </ContainerProject>
        </Container>
      </Layout>
  )
}

const Container = styled.div`
  padding: 2rem 2rem;
  padding-top: 4rem;

  @media (max-width: 1200px) {
    padding: 2rem 2rem;
    padding-left: 3rem;
  }
`

const Header = styled.div`
  h1 {
    font-weight: 500;
    font-size: 28px;
    color: var(--color-text-1);
  }

  p {
    font-weight: 400;
    color: var(--color-grey-2);
    margin-top: 1rem;
    font-size: 19px;
  }
`

const Filter = styled.div`
  display: inline-block;
  margin-top: 4rem;
  transition: all 0.4s;

  span {
    font-size: 17px;
    display: inline-block;
    font-weight: 400;
    color: var(--color-text-3);
    margin-right: 1rem;
    cursor: pointer;
    transition: all 0.4s;

    &::after {
      content: "";
      display: block;
      width: 0%;
      height: 2px;
      margin: 0 auto;
      margin-top: 0.2rem;
      background-color: var(--color-primary);
      transition: all 0.2s ease-out;
    }

    &:nth-last-of-type() {
      margin-right: 0;
    }
    &:hover {
      color: var(--color-text-1);
    }
  }

  .active {
    color: var(--color-text-1);

    &::after {
      width: 100%;
    }

    &:hover {
      color: var(--color-text-1);
    }
  }

  .none {
    transition: all 0.3s;
  }
`

const ContainerProject = styled.div`
  position: relative;
  margin-top: 2rem;
  justify-content: center;
  display: grid;
  grid-template-columns: repeat(4, minmax(220px, 1fr));
  grid-gap: 0.5rem;

  @media (max-width: 1400px) {
    grid-template-columns: repeat(3, minmax(250px, 1fr));
  }

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, minmax(250px, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(1, minmax(250px, 1fr));
    justify-content: center;
  }
`
